import clsx from "classnames";
import { twMerge } from "tailwind-merge";
import { ClassValue } from "class-variance-authority/types";

/*
 * Used to concatenate classes together in UI components.
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
